export const stripHtml = (html: string): string => {
  return html.replace(/(<([^>]+)>)/gi, '')
}
